export enum PayrollMenuEnum {
    Mileage = 1,
    Travel = 2,
    PayRates = 3,
    OnCall = 4,
    OnCallMileage = 5,
    OnCallTravel = 6,
    NonPatientActivity = 7
}
